import axios from 'axios'
import { getUserCredentials } from './authentication-utils'

export const GET = (target) => (
  axios.get(target, {
    auth: getUserCredentials()
  })
)
